import { useTranslation } from '@frontend/i18n';
import { settingsTrackingIds } from '@frontend/schedule-helpers';
import { useAppScopeStore } from '@frontend/scope';
import { SettingsLink, useSettingsNavigate } from '@frontend/settings-routing';
import { SettingsGroup } from '@frontend/settings-ui';
import { IndexRow } from '@frontend/design-system';

export const MultiLocationManageServiceProviders = () => {
  const { navigate } = useSettingsNavigate();
  const { t } = useTranslation('schedule-settings');
  const { selectedLocationIds, getScopeName } = useAppScopeStore();

  const navigateTo = (locationId: string) => {
    const route = '/schedule/manage-providers/:locationId';

    navigate({
      to: route,
      params: { locationId: locationId ?? '' },
    });
  };

  return (
    <SettingsGroup title={t('Location Settings')}>
      <IndexRow>
        {selectedLocationIds?.map((locationId) => (
          <IndexRow.Item
            key={locationId}
            as={SettingsLink}
            to='/schedule/manage-providers/:locationId'
            onClick={() => navigateTo(locationId)}
            trackingId={settingsTrackingIds.manageProvidersLocationRowItem}
          >
            <IndexRow.Item.Title>{getScopeName(locationId)}</IndexRow.Item.Title>
          </IndexRow.Item>
        ))}
      </IndexRow>
    </SettingsGroup>
  );
};
